interface ISkeletonProps {
  className?: string;
}

const Skeleton = ({ className }: ISkeletonProps) => {
  return (
    <div
      className={`relative overflow-hidden rounded-md bg-slate-200 ${className ?? ""}`}
    >
      <div className="animate-skeleton h-full w-full bg-gradient-to-r from-[#E0E0E0] via-[#F5F5F5] to-[#E0E0E0] bg-[length:400%_100%]" />
    </div>
  );
};
export default Skeleton;
